<template>
  <div>
    <template v-if="isEditing">
      <!--
          We only want to render this below when we're editing. Removes some of the unnecessary items from view.
        -->
      <div class="c-cards-editing">
        <sc-text
          tag="h2"
          class="c-cards__title"
          v-if="fields && fields.heading"
          :field="fields.heading"
        />
        <div>
          <sc-placeholder name="jss-home-cards" :rendering="rendering" />
        </div>
      </div>
    </template>
    <template v-else>
      <!--
          We only want to render this below when we're not editing.
        -->
      <div class="c-cards">
        <sc-text
          tag="h2"
          class="c-cards__title"
          v-if="fields && fields.heading"
          :field="fields.heading"
        />
        <div>
          <sc-placeholder name="jss-home-cards" :rendering="rendering" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Home-Cards',
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  computed: {
    isEditing() {
      // this.$jss is defined on the Vue instance by the SitecoreJssPlugin and provides
      // reactive access to the `sitecoreContext` provided in layout service data.
      return this.$jss.sitecoreContext().pageEditing;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-cards {
  &:deep() {
    @include padding-y(4rem, 5rem);
    color: $white;
    background: linear-gradient(
      169deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 59, 92, 1) 20%,
      rgba(0, 134, 191, 1) 100%
    );

    .c-cards__title {
      text-align: center;
      margin-bottom: 4rem;
      -webkit-text-fill-color: unset;
      @include font-styles('Arial Narrow', 2.4rem, 200, normal, 3rem, 0, $white);
      padding: 0 2rem;

      @include desktop-up {
        font-size: 3.6rem;
        line-height: 4.2rem;
        padding: 0;
      }
    }

    & > div {
      @include padding-x-thin;
      @include margin-x(auto);

      @include tablet-up {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: auto;
      }
    }

    .c-cards__item {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      background: $white;
      padding-bottom: 2.5rem;
      @include add-Shadow;
      margin: 2rem 0;

      @include tablet-up {
        width: calc(25% - 1rem);
        margin: 0 0.5rem;
      }

      @include desktop-up {
        width: calc(25% - 2rem);
        margin: 0 1rem;
      }

      &:first-child {
        @include tablet-up {
          margin-left: 0;
        }
      }

      &:last-child {
        @include tablet-up {
          margin-right: 0;
        }
      }

      .card-image {
        min-height: 6rem;
        padding: 1.8rem 1rem 2.5rem 1rem;

        @include desktop-up {
          padding: 1.8rem 2rem 2.5rem 2rem;
        }

        img {
          max-height: 6rem;
          max-width: 100%;
          height: auto;
        }
      }

      .card-content {
        font-size: 1.6rem;
        font-weight: 200;
        line-height: 2rem;
        height: 100%;
        padding: 1rem 2rem 3.5rem 2rem;
        color: $dark-blue;

        a:hover {
          text-decoration: underline;
        }

        @include tablet-up {
          font-size: 1.4rem;
          line-height: 1.8rem;
          padding: 1rem 1rem 3.5rem 1rem;
        }

        @include desktop-up {
          font-size: 2rem;
          line-height: 2.6rem;
          padding: 1rem 2rem 3.5rem 2rem;
        }
      }
      .c-cta--secondary {
        margin: 0;
      }

      > .c-cta--secondary {
        margin-left: 1rem;
        margin-bottom: 2rem;
        align-self: flex-start;
        @include desktop-up {
          margin-left: 2rem;
          margin-bottom: 0;
        }
      }

      .card-expand {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 1.4rem;
        height: 1.4rem;
        background: transparent url(~@/assets/images/icon-expand.svg) no-repeat 50%;
        border: none;
        margin: 0;
        padding: 2rem;
        z-index: 1;
      }
    }
  }
}

// Editing View
.c-cards-editing {
  &:deep() {
    .c-cards__item {
      padding: 2rem;
      border-top: 0.4rem solid $orange;
    }

    .card-expand {
      display: none;
    }

    .c-modal {
      border: solid 0.1rem $gray;
      padding: 2rem;
    }

    .c-modal__close {
      display: none;
    }
  }
}
</style>
